import { Slider as BpSlider } from "@blueprintjs/core";
import { IWidgetProps } from "decorator-form";
import React from "react";

import { registerWidget } from "common/form/register";

interface ISliderOptions {
	max: number;
	min: number;
	stepSize: number;
}

interface ISliderProps extends IWidgetProps<number> {
	options: ISliderOptions;
}

function Slider(props: ISliderProps) {
	return (
		<BpSlider
			value={props.value}
			onChange={props.onChange}
			onRelease={props.onChange}
			disabled={props.disabled || props.readonly}
			{...props.options}
		/>
	);
}

Slider.withOptions = (options: ISliderOptions) =>
	(props: IWidgetProps<number>) =>
	<Slider {...props} options={options} />;

Slider.registerWithOptions = (options: ISliderOptions) => registerWidget(Slider.withOptions(options), 'number');

export default Slider;



// WEBPACK FOOTER //
// ./src/common/form/widgets/common/Slider.tsx